import { onValue, push, ref, remove, update } from 'firebase/database';
import { useEffect, useState } from 'react';
import { database } from '../firebase';

const CITIES = ['Agar Malwa','Alirajpur','Anuppur','Ashok Nagar','Balaghat','Barwani','Betul','Bhind','Bhopal','Burhanpur','Chhatarpur','Chhindwara','Damoh','Datia','Dewas','Dhar','Dindori','Guna','Gwalior','Harda','Hoshangabad','Indore','Jabalpur','Jhabua','Katni','Khandwa','Khargone','Mandla','Mandsaur','Morena','Narsinghpur','Neemuch','Panna','Raisen','Rajgarh','Ratlam','Rewa','Sagar','Satna','Sehore','Seoni','Shahdol','Shajapur','Sheopur','Shivpuri','Sidhi','Singrauli','Tikamgarh','Ujjain','Umaria','Vidisha'];

const EMPTY_LEAD = { name:'', gender:'', dob:'', mobile:'', altMobile:'', email:'', qualification:'', parentName:'', date: new Date().toISOString().split('T')[0], remarks:'', state:'Madhya Pradesh', city:'', pincode:'', address:'', idType:'', idNumber:'', course:'', leadScore:'', status:'New', followUpDate:'', channel:'', source:'' };

const AddLeadModal = ({ onClose, onAdd }) => {
    const [form, setForm]   = useState({ ...EMPTY_LEAD });
    const [saving, setSaving] = useState(false);
    const [enrollOnAdd, setEnrollOnAdd] = useState(false);
    const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

    const handleAdd = async () => {
      if (!form.name || !form.mobile) { alert('Name and Mobile are required.'); return; }
      // basic validations
      if (form.mobile && form.mobile.replace(/\D/g, '').length < 10) { alert('Enter a valid 10 digit mobile number.'); return; }
      if (form.pincode && form.pincode.replace(/\D/g, '').length > 0 && form.pincode.replace(/\D/g, '').length < 6) { alert('Enter a valid 6 digit pincode.'); return; }
      if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) { alert('Enter a valid email address.'); return; }

      setSaving(true);
      await onAdd(form);

      // if user chose to enroll immediately, also add to Enrolled_students
      if (enrollOnAdd) {
        const student = {
          name: form.name,
          gender: form.gender,
          dob: form.dob,
          mobile: form.mobile,
          altMobile: form.altMobile,
          email: form.email,
          qualification: form.qualification,
          parentName: form.parentName,
          date: form.date || new Date().toISOString(),
          remarks: form.remarks,
          state: form.state,
          city: form.city,
          pincode: form.pincode,
          address: form.address,
          idType: form.idType,
          idNumber: form.idNumber,
          course: form.course,
          status: 'Active'
        };
        await push(ref(database, 'Enrolled_students'), student);
      }

      setSaving(false);
      onClose();
    };

    return (
      <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.45)', zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header py-2" style={{ background: '#90b732' }}>
              <h6 className="modal-title text-white mb-0"><i className="bi bi-person-plus me-2"></i>Add New Lead</h6>
              <button className="btn-close btn-close-white btn-sm" onClick={onClose}></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <div className="row g-2" style={{ fontSize: '13px' }}>
                {/* Personal */}
                <div className="col-12"><h6 className="mb-2">Personal</h6></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Full Name <span className="text-danger">*</span></label><input className="form-control form-control-sm" value={form.name} onChange={e => set('name', e.target.value)} /></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Gender</label><select className="form-select form-select-sm" value={form.gender} onChange={e => set('gender', e.target.value)}><option value="">Select</option><option>Male</option><option>Female</option></select></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Date of Birth</label><input type="date" className="form-control form-control-sm" value={form.dob} onChange={e => set('dob', e.target.value)} /></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Mobile <span className="text-danger">*</span></label><input inputMode="numeric" maxLength={10} className="form-control form-control-sm" value={form.mobile} onChange={e => set('mobile', e.target.value.replace(/\D/g, ''))} /></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Alt. Mobile</label><input inputMode="numeric" maxLength={10} className="form-control form-control-sm" value={form.altMobile} onChange={e => set('altMobile', e.target.value.replace(/\D/g, ''))} /></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Email</label><input type="email" className="form-control form-control-sm" value={form.email} onChange={e => set('email', e.target.value)} /></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Qualification</label><select className="form-select form-select-sm" value={form.qualification} onChange={e => set('qualification', e.target.value)}><option value="">Select</option>{['Any Graduate','X Standard','ITI/Diploma','XII Standard','B.Com','B.E/B.Tech','BBA/BBM','M.Com','MBA','Professional qualification','Other'].map(q => <option key={q}>{q}</option>)}</select></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Parent's Name</label><input className="form-control form-control-sm" value={form.parentName} onChange={e => set('parentName', e.target.value)} /></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Date Added</label><input type="date" className="form-control form-control-sm" value={form.date} onChange={e => set('date', e.target.value)} /></div>
                <div className="col-12"><label className="form-label mb-1 fw-semibold">Remarks</label><textarea className="form-control form-control-sm" rows={2} value={form.remarks} onChange={e => set('remarks', e.target.value)} /></div>

                {/* Address */}
                <div className="col-12 mt-2"><h6 className="mb-2">Address</h6></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">State</label><select className="form-select form-select-sm" value={form.state} onChange={e => set('state', e.target.value)}><option value="">Select</option><option>Madhya Pradesh</option></select></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">City</label><select className="form-select form-select-sm" value={form.city} onChange={e => set('city', e.target.value)}><option value="">Select</option>{CITIES.map(c => <option key={c}>{c}</option>)}</select></div>
                <div className="col-md-4"><label className="form-label mb-1 fw-semibold">Pincode</label><input inputMode="numeric" maxLength={6} className="form-control form-control-sm" value={form.pincode} onChange={e => set('pincode', e.target.value.replace(/\D/g, ''))} /></div>
                <div className="col-md-6"><label className="form-label mb-1 fw-semibold">ID Proof Type</label><select className="form-select form-select-sm" value={form.idType} onChange={e => set('idType', e.target.value)}><option value="">Select</option>{['Aadhar','PAN','Voter ID','Passport','Driving License','Ration Card'].map(t => <option key={t}>{t}</option>)}</select></div>
                <div className="col-md-6"><label className="form-label mb-1 fw-semibold">ID Proof Number</label><input className="form-control form-control-sm" value={form.idNumber} onChange={e => set('idNumber', e.target.value)} /></div>
                <div className="col-12"><label className="form-label mb-1 fw-semibold">Address</label><textarea className="form-control form-control-sm" rows={2} value={form.address} onChange={e => set('address', e.target.value)} /></div>

                {/* Course & Lead */}
                <div className="col-12 mt-2"><h6 className="mb-2">Course & Lead</h6></div>
                <div className="col-md-6"><label className="form-label mb-1 fw-semibold">Course Interested In</label><select className="form-select form-select-sm" value={form.course} onChange={e => set('course', e.target.value)}><option value="">Select</option>{['Tally Professional','Tally Expert','GST Course','TallyEssential','Office Automation','Payroll & Income Tax'].map(c => <option key={c}>{c}</option>)}</select></div>
                <div className="col-md-6"><label className="form-label mb-1 fw-semibold">Lead Score</label><select className="form-select form-select-sm" value={form.leadScore} onChange={e => set('leadScore', e.target.value)}><option value="">Select</option>{['Hot','Warm','Cold'].map(s => <option key={s}>{s}</option>)}</select></div>
                <div className="col-md-6"><label className="form-label mb-1 fw-semibold">Status</label><select className="form-select form-select-sm" value={form.status} onChange={e => set('status', e.target.value)}><option value="">Select</option>{['New','Contacted','Interested','Not Interested','Follow Up'].map(s => <option key={s}>{s}</option>)}</select></div>
                <div className="col-md-6"><label className="form-label mb-1 fw-semibold">Follow Up Date</label><input type="date" className="form-control form-control-sm" value={form.followUpDate} onChange={e => set('followUpDate', e.target.value)} /></div>
                <div className="col-md-6"><label className="form-label mb-1 fw-semibold">Channel</label><input className="form-control form-control-sm" value={form.channel} onChange={e => set('channel', e.target.value)} /></div>
                <div className="col-md-6"><label className="form-label mb-1 fw-semibold">Source</label><input className="form-control form-control-sm" value={form.source} onChange={e => set('source', e.target.value)} /></div>

                <div className="col-12 mt-2">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="enrollOnAdd" checked={enrollOnAdd} onChange={e => setEnrollOnAdd(e.target.checked)} />
                    <label className="form-check-label" htmlFor="enrollOnAdd">Also enroll this lead as a student</label>
                  </div>
                </div>

              </div>
            </div>
            <div className="modal-footer py-2 d-flex justify-content-end gap-2">
              <button className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</button>
              <button className="btn btn-sm text-white" style={{ background: '#90b732' }} onClick={handleAdd} disabled={saving}>
                {saving ? 'Saving...' : <><i className="bi bi-person-plus me-1"></i>Add Lead</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

const EditModal = ({ record, onClose, onSave, onDelete, onEnroll }) => {
  const [form, setForm]         = useState({ ...record });
  const [saving, setSaving]     = useState(false);
  const [enrolling, setEnrolling] = useState(false);
  const [tab, setTab]           = useState('personal');
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const fmtDate = (val) => val ? new Date(val).toISOString().split('T')[0] : '';

  const handleSave = async () => {
    // validations
    if (form.mobile && form.mobile.replace(/\D/g, '').length < 10) { alert('Enter a valid 10 digit mobile number.'); return; }
    if (form.pincode && form.pincode.replace(/\D/g, '').length > 0 && form.pincode.replace(/\D/g, '').length < 6) { alert('Enter a valid 6 digit pincode.'); return; }
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) { alert('Enter a valid email address.'); return; }
    setSaving(true);
    await onSave(form);
    setSaving(false);
    onClose();
  };

  const handleDelete = async () => {
    if (!window.confirm('Delete this lead permanently?')) return;
    await onDelete(record.id);
    onClose();
  };

  const handleEnroll = async () => {
    if (!window.confirm(`Enroll ${form.name} as a student? They will be moved to Students Listing.`)) return;
    setEnrolling(true);
    await onEnroll(form);
    setEnrolling(false);
    onClose();
  };

  return (
    <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.45)', zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header py-2" style={{ background: '#90b732' }}>
            <h6 className="modal-title text-white mb-0">
              <i className="bi bi-pencil-square me-2"></i>Edit Lead — {record.name}
            </h6>
            <button className="btn-close btn-close-white btn-sm" onClick={onClose}></button>
          </div>

          <div className="px-3 pt-2" style={{ borderBottom: '1px solid #dee2e6' }}>
            <ul className="nav nav-tabs border-0" style={{ fontSize: '13px' }}>
              {[['personal','Personal'],['address','Address'],['course','Course & Lead']].map(([key, label]) => (
                <li className="nav-item" key={key}>
                  <button
                    className={`nav-link py-1 px-3 ${tab === key ? 'active fw-semibold' : 'text-muted'}`}
                    style={{ border: 'none', borderBottom: tab === key ? '2px solid #90b732' : '2px solid transparent', background: 'none', color: tab === key ? '#90b732' : '' }}
                    onClick={() => setTab(key)}
                  >{label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            <div className="row g-2" style={{ fontSize: '13px' }}>

              {tab === 'personal' && <>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Full Name</label>
                  <input className="form-control form-control-sm" value={form.name || ''} onChange={e => set('name', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Gender</label>
                  <select className="form-select form-select-sm" value={form.gender || ''} onChange={e => set('gender', e.target.value)}>
                    <option value="">Select</option>
                    <option>Male</option><option>Female</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Date of Birth</label>
                  <input type="date" className="form-control form-control-sm" value={fmtDate(form.dob)} onChange={e => set('dob', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Mobile</label>
                  <input inputMode="numeric" maxLength={10} className="form-control form-control-sm" value={form.mobile || ''} onChange={e => set('mobile', e.target.value.replace(/\D/g, ''))} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Alt. Mobile</label>
                  <input inputMode="numeric" maxLength={10} className="form-control form-control-sm" value={form.altMobile || ''} onChange={e => set('altMobile', e.target.value.replace(/\D/g, ''))} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Email</label>
                  <input type="email" className="form-control form-control-sm" value={form.email || ''} onChange={e => set('email', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Qualification</label>
                  <select className="form-select form-select-sm" value={form.qualification || ''} onChange={e => set('qualification', e.target.value)}>
                    <option value="">Select</option>
                    {['Any Graduate','X Standard','ITI/Diploma','XII Standard','B.Com','B.E/B.Tech','BBA/BBM','M.Com','MBA','Professional qualification','Other'].map(q => <option key={q}>{q}</option>)}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Parent's Name</label>
                  <input className="form-control form-control-sm" value={form.parentName || ''} onChange={e => set('parentName', e.target.value)} />
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Date Added</label>
                  <input type="date" className="form-control form-control-sm" value={fmtDate(form.date)} onChange={e => set('date', e.target.value)} />
                </div>
                <div className="col-12">
                  <label className="form-label mb-1 fw-semibold">Remarks</label>
                  <textarea className="form-control form-control-sm" rows={2} value={form.remarks || ''} onChange={e => set('remarks', e.target.value)} />
                </div>
              </>}

              {tab === 'address' && <>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">State</label>
                  <select className="form-select form-select-sm" value={form.state || ''} onChange={e => set('state', e.target.value)}>
                    <option value="">Select</option>
                    <option>Madhya Pradesh</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">City</label>
                  <select className="form-select form-select-sm" value={form.city || ''} onChange={e => set('city', e.target.value)}>
                    <option value="">Select</option>
                    {CITIES.map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label mb-1 fw-semibold">Pincode</label>
                  <input inputMode="numeric" maxLength={6} className="form-control form-control-sm" value={form.pincode || ''} onChange={e => set('pincode', e.target.value.replace(/\D/g, ''))} />
                </div>
                <div className="col-md-6">
                  <label className="form-label mb-1 fw-semibold">ID Proof Type</label>
                  <select className="form-select form-select-sm" value={form.idType || ''} onChange={e => set('idType', e.target.value)}>
                    <option value="">Select</option>
                    {['Aadhar','PAN','Voter ID','Passport','Driving License','Ration Card'].map(t => <option key={t}>{t}</option>)}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label mb-1 fw-semibold">ID Proof Number</label>
                  <input className="form-control form-control-sm" value={form.idNumber || ''} onChange={e => set('idNumber', e.target.value)} />
                </div>
                <div className="col-12">
                  <label className="form-label mb-1 fw-semibold">Address</label>
                  <textarea className="form-control form-control-sm" rows={2} value={form.address || ''} onChange={e => set('address', e.target.value)} />
                </div>
              </>}

              {tab === 'course' && <>
                <div className="col-md-6">
                  <label className="form-label mb-1 fw-semibold">Course Interested In</label>
                  <select className="form-select form-select-sm" value={form.course || ''} onChange={e => set('course', e.target.value)}>
                    <option value="">Select</option>
                    {['Tally Professional','Tally Expert','GST Course','TallyEssential','Office Automation','Payroll & Income Tax'].map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label mb-1 fw-semibold">Lead Score</label>
                  <select className="form-select form-select-sm" value={form.leadScore || ''} onChange={e => set('leadScore', e.target.value)}>
                    <option value="">Select</option>
                    {['Hot','Warm','Cold'].map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label mb-1 fw-semibold">Status</label>
                  <select className="form-select form-select-sm" value={form.status || ''} onChange={e => set('status', e.target.value)}>
                    <option value="">Select</option>
                    {['New','Contacted','Interested','Not Interested','Follow Up'].map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label mb-1 fw-semibold">Follow Up Date</label>
                  <input type="date" className="form-control form-control-sm" value={fmtDate(form.followUpDate)} onChange={e => set('followUpDate', e.target.value)} />
                </div>
                <div className="col-md-6">
                  <label className="form-label mb-1 fw-semibold">Channel</label>
                  <input className="form-control form-control-sm" value={form.channel || ''} onChange={e => set('channel', e.target.value)} />
                </div>
                <div className="col-md-6">
                  <label className="form-label mb-1 fw-semibold">Source</label>
                  <input className="form-control form-control-sm" value={form.source || ''} onChange={e => set('source', e.target.value)} />
                </div>
              </>}

            </div>
          </div>

          <div className="modal-footer py-2 d-flex justify-content-between">
            <button className="btn btn-sm btn-outline-danger" onClick={handleDelete}>
              <i className="bi bi-trash me-1"></i>Delete
            </button>
            <div className="d-flex gap-2">
              <button className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</button>
              <button className="btn btn-sm text-white" style={{ background: '#90b732' }} onClick={handleSave} disabled={saving}>
                {saving ? 'Saving...' : <><i className="bi bi-check-lg me-1"></i>Save</>}
              </button>
              <button className="btn btn-sm btn-success" onClick={handleEnroll} disabled={enrolling}>
                {enrolling ? 'Enrolling...' : <><i className="bi bi-person-check me-1"></i>Enroll Student</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const StudentsTable = () => {
  const [allData, setAllData]           = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading]           = useState(true);
  const [search, setSearch]             = useState('');
  const [showFilters, setShowFilters]   = useState(false);
  const [selected, setSelected]         = useState([]);
  const [activeTab, setActiveTab]       = useState('all');
  const [editRecord, setEditRecord]     = useState(null);
  const [toast, setToast]               = useState('');
  const [showAdd, setShowAdd]           = useState(false);
  const [filters, setFilters]           = useState({ mobile: '', email: '', date: '', source: '', channel: '' });

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3500); };

  useEffect(() => {
    const unsub = onValue(ref(database, 'student_leads'), (snap) => {
      const raw = snap.val();
      const data = raw ? Object.entries(raw).map(([id, v]) => ({ id, ...v })) : [];
      setAllData(data);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    let data = [...allData];
    if (search) data = data.filter(r =>
      [r.name, r.email, r.mobile, r.course, r.city].some(f => f?.toLowerCase().includes(search.toLowerCase()))
    );
    if (filters.mobile)  data = data.filter(r => r.mobile?.toLowerCase().includes(filters.mobile.toLowerCase()));
    if (filters.email)   data = data.filter(r => r.email?.toLowerCase().includes(filters.email.toLowerCase()));
    if (filters.source)  data = data.filter(r => r.source?.toLowerCase().includes(filters.source.toLowerCase()));
    if (filters.channel) data = data.filter(r => r.channel?.toLowerCase().includes(filters.channel.toLowerCase()));
    if (filters.date)    data = data.filter(r => new Date(r.date).toLocaleDateString() === new Date(filters.date).toLocaleDateString());
    setFilteredData(data);
  }, [search, filters, allData]);

  const toggleSelect = (id) => setSelected(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);
  const toggleAll    = () => setSelected(selected.length === filteredData.length ? [] : filteredData.map(r => r.id));
  const resetFilters = () => setFilters({ mobile: '', email: '', date: '', source: '', channel: '' });

  const handleSave = async (form) => {
    const { id, ...data } = form;
    await update(ref(database, `student_leads/${id}`), data);
    showToast('Lead updated successfully.');
  };

  const handleDelete = async (id) => {
    await remove(ref(database, `student_leads/${id}`));
    showToast('Lead deleted.');
  };

  const handleEnroll = async (form) => {
    const { id, ...data } = form;
    await push(ref(database, 'Enrolled_students'), { ...data, enrolledDate: new Date().toISOString() });
    await remove(ref(database, `student_leads/${id}`));
    showToast(`${form.name} enrolled and moved to Students Listing.`);
  };

  const handleAdd = async (form) => {
    await push(ref(database, 'student_leads'), form);
    showToast(`Lead for ${form.name} added successfully.`);
  };

  const exportCSV = () => {
    const rows = [['Name','Mobile','Email','City','Course','Channel','Source','Date']];
    filteredData.forEach(r => rows.push([r.name||'',r.mobile||'',r.email||'',r.city||'',r.course||'',r.channel||'',r.source||'',r.date?new Date(r.date).toLocaleDateString():'']));
    const a = document.createElement('a');
    a.href = 'data:text/csv,' + encodeURIComponent(rows.map(r => r.join(',')).join('\n'));
    a.download = 'leads.csv'; a.click();
  };

  const scoreColor = (s) => ({ Hot:'#e74c3c', Warm:'#e67e22', Cold:'#3498db' }[s] || '#aaa');
  const statusColor = (s) => ({ New:'#6c757d', Contacted:'#17a2b8', Interested:'#90b732', 'Not Interested':'#e74c3c', 'Follow Up':'#e67e22' }[s] || '#aaa');

  return (
    <div className="px-1">
      {editRecord && (
        <EditModal
          record={editRecord}
          onClose={() => setEditRecord(null)}
          onSave={handleSave}
          onDelete={handleDelete}
          onEnroll={handleEnroll}
        />
      )}

      {showAdd && (
        <AddLeadModal
          onClose={() => setShowAdd(false)}
          onAdd={handleAdd}
        />
      )}

      {toast && (
        <div className="alert py-2 px-3 mb-2 d-flex align-items-center gap-2" style={{ fontSize: 13, background: '#edf7d6', color: '#4d7a10', border: '1px solid #90b732' }}>
          <i className="bi bi-check-circle-fill" style={{ color: '#90b732' }}></i> {toast}
        </div>
      )}

      <div className="d-flex align-items-center justify-content-between mb-3 pb-2" style={{ borderBottom: '2px solid #90b732' }}>
        <h6 className="fw-bold mb-0" style={{ color: '#90b732' }}>
          <i className="bi bi-funnel me-2"></i>Student Leads
        </h6>
        <span className="badge" style={{ background: '#90b732' }}>{filteredData.length} records</span>
      </div>

      <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
        <div className="input-group" style={{ maxWidth: '280px' }}>
          <span className="input-group-text bg-white"><i className="bi bi-search text-muted"></i></span>
          <input type="text" className="form-control border-start-0" placeholder="Search name, email, mobile..."
            value={search} onChange={e => setSearch(e.target.value)} style={{ fontSize: '13px' }} />
        </div>
        <button className="btn btn-sm btn-outline-success" onClick={exportCSV}>
          <i className="bi bi-file-earmark-excel me-1"></i>Export
        </button>
        <button className="btn btn-sm text-white" style={{ background: '#90b732' }} onClick={() => setShowAdd(true)}>
          <i className="bi bi-person-plus me-1"></i>Add Lead
        </button>
      </div>

      {showFilters && (
        <div className="card mb-3" style={{ borderColor: '#90b732' }}>
          <div className="card-body py-2 px-3">
            <div className="row g-2 align-items-end">
              {[['mobile','Mobile'],['email','Email'],['source','Source'],['channel','Channel']].map(([key, label]) => (
                <div className="col-md-2" key={key}>
                  <label className="form-label mb-1" style={{ fontSize: '12px' }}>{label}</label>
                  <input className="form-control form-control-sm" placeholder={`Filter by ${label.toLowerCase()}`}
                    value={filters[key]} onChange={e => setFilters(p => ({ ...p, [key]: e.target.value }))} />
                </div>
              ))}
              <div className="col-md-2">
                <label className="form-label mb-1" style={{ fontSize: '12px' }}>Date</label>
                <input type="date" className="form-control form-control-sm"
                  value={filters.date} onChange={e => setFilters(p => ({ ...p, date: e.target.value }))} />
              </div>
              <div className="col-md-2">
                <button className="btn btn-sm btn-outline-danger w-100" onClick={resetFilters}>Reset</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="d-flex gap-1 mb-2">
        {['all','mine','my account'].map(t => (
          <button key={t} onClick={() => setActiveTab(t)}
            className="btn btn-sm"
            style={{ fontSize: '12px', textTransform: 'capitalize', background: activeTab === t ? '#90b732' : '', color: activeTab === t ? '#fff' : '', border: '1px solid #ccc' }}>
            {t}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-center py-5"><div className="spinner-border" style={{ color: '#90b732' }}></div></div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover table-bordered align-middle mb-0" style={{ fontSize: '12.5px' }}>
            <thead style={{ background: '#90b732', color: '#fff' }}>
              <tr>
                <th style={{ width: '36px' }}>
                  <input type="checkbox" className="form-check-input"
                    checked={selected.length === filteredData.length && filteredData.length > 0}
                    onChange={toggleAll} />
                </th>
                <th>#</th><th>Name</th><th>Mobile</th><th>Email</th>
                <th>City</th><th>Course</th><th>Score</th><th>Status</th><th>Date</th><th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? filteredData.map((r, i) => (
                <tr key={r.id} className={selected.includes(r.id) ? 'table-warning' : ''}>
                  <td><input type="checkbox" className="form-check-input" checked={selected.includes(r.id)} onChange={() => toggleSelect(r.id)} /></td>
                  <td className="text-muted">{i + 1}</td>
                  <td className="fw-semibold">{r.name || '—'}</td>
                  <td>{r.mobile || '—'}</td>
                  <td>{r.email || '—'}</td>
                  <td>{r.city || '—'}</td>
                  <td>{r.course ? <span className="badge bg-light text-dark border">{r.course}</span> : '—'}</td>
                  <td>{r.leadScore ? <span className="badge" style={{ background: scoreColor(r.leadScore) }}>{r.leadScore}</span> : '—'}</td>
                  <td>{r.status ? <span className="badge" style={{ background: statusColor(r.status) }}>{r.status}</span> : '—'}</td>
                  <td>{r.date ? new Date(r.date).toLocaleDateString() : '—'}</td>
                  <td>
                    <div className="d-flex gap-1">
                      <button className="btn btn-sm py-0 px-2 text-white" style={{ background: '#90b732' }} title="Edit" onClick={() => setEditRecord(r)}>
                        <i className="bi bi-pencil"></i>
                      </button>
                      <button className="btn btn-sm btn-success py-0 px-2" title="Enroll Student" onClick={() => setEditRecord(r)}>
                        <i className="bi bi-person-check"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan="11" className="text-center text-muted py-4">No leads found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default StudentsTable;
